<template>
  <v-container fluid class="blogPostCont d-flex flex-column justify-start align-center">

    <div class="blog-post d-flex flex-column justify-center align-start ma-5 pa-5">
      <h1 class="bp-title mt-12 mb-2 paral">{{upperCase(currPost.title)}}</h1>
      <div class="bp-card-image" 
        :style="{ backgroundImage: 'url('+ require('../../images/' + currPost.url + '.jpg')+')',
                  backgroundPosition: currPost.urlPosition }">
      </div>
      <div class="bp-underHead d-flex justify-space-between align-start mt-2 mb-3">
        <h1 class="bp-subtitle paral">{{upperCase(currPost.subtitle)}}</h1>
        <h1 class="bp-date paral">{{currPost.date}}</h1>
      </div>
      <div v-for="(value, name, index) in currPost" :key="index.index">
        <div v-if="index>5 && matches(name,'heading')" class="bp-heading paral my-4"> {{value}} </div>
        <div v-if="index>5 && matches(name,'subhead')" class="bp-subhead paral"> {{value}} </div>
        <div v-if="index>5 && matches(name,'text')" class="bp-text"> {{value}} </div>
        <div v-html="value" v-if="index>5 && matches(name,'paragraph')" class="bp-paragraph fw3"> {{value}} </div>
        <div v-if="index>5 && matches(name,'figure')" class="bp-figure"
          :style="{ 
            backgroundImage: 'url('+ require('../../images/blog/' + value + '.jpg')+')',
            height: getHeight(name) }">
        </div>
      </div>
    </div>

    <div class="d-flex justify-space-between align-start px-12">
      <div class="blogNavHolder"> 
        <blog-nav :id="id" :blogNum="blogNum" pos=1></blog-nav>
      </div>
      <div class="blogNavHolder"> 
        <blog-nav :id="id" :blogNum="blogNum" pos=-1></blog-nav>
      </div>
    </div>



  </v-container>
</template>
<!--=================================================================================-->
<!--=====================================================================SCRIPTS=====-->
<!--=================================================================================-->
<script>
import Blogs from './Blogs.json';
import BlogNav from './BlogNav.vue'

export default {
  name: "blog-post",
  components: {
    blogNav: BlogNav
  },
  data() {
    return {
      Blogs,
      blogNum: 2,
      image: "",
      id: this.$route.params.id,
      currPost: "",
    };
  },
  watch: {
    '$route'(to){ this.id = to.params.id;},
    id(){ this.getPosts();}
  },
  methods: {
    getPosts(){ this.currPost = this.Blogs[this.id];},
    upperCase(lowerCase){ return lowerCase.toUpperCase();},
    matches(name, comparator){ return name.includes(comparator);},
    getHeight(name){ return this.currPost['height' + name.slice(6)];}
  },
  created() {
    this.getPosts();
  }
}
</script>
<!--=================================================================================-->
<!--=====================================================================STYLING=====-->
<!--=================================================================================-->
<style>
.blogPostCont{
  position: relative;
  width: 100vw;
  background-color: white;
  padding: 50px 0;
  top: 0;
  left:0;}
.blog-post{
  width: 80vw;
  min-width: 330px;
  max-width: 1000px;
  height: auto;
  padding: 0;
  margin: 0;}
.bp-title{
  font-size: calc(18px + 2vw);
  line-height:  calc(16px + 2vw);
  color: #2F2E2E;}
.bp-underHead{ width: 100%;}
.bp-subtitle{
  font-size: calc(15px + 2vw);
  line-height:  calc(10px + 2vw);
  text-align: left;
  width: 70%;}
.bp-date{
  width: 30%;
  font-size: calc(12px + 2vw);
  line-height:  calc(8px + 2vw);
  line-height: 0.85em;
  text-align: right;}
.bp-abstract{
  position:relative;
  font-size: 2em;}
.bp-heading{
  color: #2F2E2E;
  font-size: calc(20px + 2vw);
  line-height:  calc(30px + 1vw);
  font-family: paralucent-condensed,sans-serif;
  font-weight: 600;
  padding-Bottom: 10px;
  font-style: normal;
  text-align: left;}
.bp-subhead{
  color: #2F2E2E;
  font-size: calc(15px + 2vw);
  line-height:  calc(25px + 1vw);
  font-family: paralucent-condensed,sans-serif;
  font-weight: 600;
  font-style: normal;
  text-align: left;
  margin: 0.5em 0em 0em;
  padding: 0em 0em 0.6em;}
.bp-paragraph, .bp-text{
  margin: 0em 0em 1em;
  color: #282828EE;
  font-family: 'Avenir', 'Lato', Helvetica,Arial,sans-serif;
  font-size: 22px;
  line-height: 28px;
  text-align: left;}
.bp-figure{
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  margin: 10px 0;
  width: 80vw;
  min-width: 300px;
  max-width: 1000px;
  max-height: 95vh; }
.bp-card-image{
  background-size: cover;
  width: 100%;
  height: 40vh;
  min-height: 350px;}
.blogNavHolder{
  padding: 0px 3vw;
  padding-bottom: 50px;
  width: 40vw;
  min-width: 170px;
  max-width: 600px;
}
</style>